package com.appcreator.client.revenuecat

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.appcreator.blueprint.revenuecat.RevenuecatPaywallComponent
import com.appcreator.compose.components.ComponentComposable

@Composable
actual fun PaywallComposable(
    modifier: Modifier,
    component: RevenuecatPaywallComponent
) {

    Column(
        modifier = modifier.fillMaxSize().padding(horizontal = 32.dp),
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        Box(
            modifier = modifier
                .fillMaxWidth()
                .weight(1f, true)
                .padding(32.dp),
            contentAlignment = Alignment.Center,
        ) {

        }

        Spacer(modifier = modifier.padding(8.dp))
            Text(
                text = "Paywall is currently unsupported on web",
                style = MaterialTheme.typography.headlineSmall
            )

        Button(
            onClick = { },
            colors = ButtonDefaults.buttonColors(
                containerColor = MaterialTheme.colorScheme.primary,
                contentColor = MaterialTheme.colorScheme.onPrimary
            ),
            modifier = modifier
                .fillMaxWidth()
                .padding(
                    vertical = 8.dp,
                ),
        ) {
            Text(text = "(Example) £x.xx for 1 month")
        }

        Spacer(modifier = modifier.padding(16.dp))
    }
}
